import type { PaymentMetaOptionDetails } from 'domain/payments/types';

export const BENEFICIARY_SOURCE = {
  erp: 'erp',
  user: 'user',
} as const;

export type BeneficiarySource = (typeof BENEFICIARY_SOURCE)[keyof typeof BENEFICIARY_SOURCE];

export interface BeneficiaryDetailsResponse {
  id: string;
  vendorId: string;
  providerName: string;
  source: BeneficiarySource;
  isDefault: boolean;
  details: PaymentMetaOptionDetails;
  vendorDisplayName: string;
}

export interface SelectOption {
  label: string;
  value: string;
}

export interface BeneficiaryField {
  name: string;
  label: string;
  type: 'text' | 'email' | 'select' | 'multi-select';
  placeholder?: string;
  helpText?: string;
  subscription?: string;
  options?: SelectOption[];
  defaultValue?: string | string[];
}

export interface BeneficiaryFormData {
  fields: BeneficiaryField[];
}

export type FormValues = Record<string, string | string[]>;

export interface BeneficiaryModalProps {
  onClose: () => void;
  onSubmit: (data: Record<string, unknown>) => Promise<unknown>;
  vendorId: string;
  vendorName: string;
  existingAccountsCount: number;
  beneficiaryId?: string;
  isEditable?: boolean;
  isDefault?: boolean;
  isExternal?: boolean;
}
